import {
  LeaderboardPeriodResponse,
  LeaderboardStat,
  LeaderboardStatPeriod,
  LeagueFilter,
  Period,
  WeeklyTotals,
} from 'models';

import { api } from './api';

const contestApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLeaderboard: builder.query<
      LeaderboardStat,
      { contestId: number | string | null; friends?: boolean; league?: LeagueFilter }
    >({
      query: ({ contestId, friends, league }) => {
        return {
          url: `contest/leaderboard/`,
          method: 'GET',
          params: {
            ...(contestId !== null && { contestId }),
            ...(friends && { friends }),
            ...(league && { league }),
          },
        };
      },
    }),
    getLeaderboardByPeriod: builder.query<
      LeaderboardPeriodResponse,
      { period: Period; date?: string; friends?: boolean; league?: LeagueFilter }
    >({
      query: ({ period, date, friends, league }) => {
        if (!date) {
          throw new Error('Date parameter is required for getLeaderboardByPeriod');
        }

        const url = `contest/leaderboard/${period}/${date}/`;

        return {
          url,
          params: {
            ...(friends && { friends }),
            ...(league && { league }),
          },
        };
      },
    }),
    getLeaderboardById: builder.query<LeaderboardStatPeriod, { leaderboardId: number; friends?: boolean }>({
      query: ({ leaderboardId, friends }) => {
        return {
          url: `contest/leaderboard/${leaderboardId}/`,
          params: {
            ...(friends && { friends }),
          },
        };
      },
    }),
    getWeeklyTotals: builder.query<WeeklyTotals, { startDate: string; endDate: string }>({
      query: ({ startDate, endDate }) => {
        return {
          url: `contest/weekly_totals/`,
          params: {
            startDate,
            endDate,
          },
        };
      },
    }),
  }),
});

export const {
  useGetLeaderboardQuery,
  useLazyGetLeaderboardQuery,
  useGetLeaderboardByPeriodQuery,
  useLazyGetLeaderboardByPeriodQuery,
  useGetLeaderboardByIdQuery,
  useLazyGetLeaderboardByIdQuery,
  useGetWeeklyTotalsQuery,
} = contestApi;
